import Observer from './observer';

const defaultTreshhold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
const observers = new Map();

/**
 * Директива для intersection observer
 * v-intersect="callback"
 *
 * Модификатор once - пересечение сработает только раз
 * v-intersect.once="callback"
 *
 * Параметры обзервера вместо коллбэка
 * v-intersect.once="{
 *      rootMargin:'0px 0px 200px 0px',
 *      treshold: [0.5, 1],
 *      onIntersection: callback,
 *      onOutIntersection: outCallback
 * }"
 */
export default {
  async bind(
    $el,
    {
      value,
      modifiers: { once },
    }
  ) {
    if (!value) {
      throw new Error('[v-intersect]: Intersection callback or observer options not provided.');
    }

    const options = typeof value === 'function' ? {} : value;

    const observer = new Observer({
      threshold: options.threshold ? options.threshold : defaultTreshhold,
      rootMargin: options.rootMargin,
    });

    observers.set($el, observer);

    const callbacks = {
      onIntersection: (entry) => {
        if (once === true) {
          observer.remove($el);
        }
        if (typeof value === 'function') {
          value(entry);
          return;
        }
        if (typeof options.onIntersection === 'function') {
          options.onIntersection(entry);
        }
      },
    };

    if (typeof options.onOutIntersection === 'function') {
      callbacks.onOutIntersection = (entry) => {
        if (options.onOutIntersection) {
          options.onOutIntersection(entry);
        }
      };
    }
    observer.add($el, callbacks);
  },
  unbind($el) {
    if (observers.has($el)) {
      observers.get($el).remove($el);
      observers.delete($el);
    }
  },
};



// WEBPACK FOOTER //
// ./src/shared/intersect/intersect.js